import { useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import { modalStyle } from "../../../utils/modal-style";
import SelectInput from "../../Select/SelectInput";

import "./CreateCovep.scss";
import { getCompetitors } from "../../../services/competitor-service";
import { useEffect } from "react";
import { createCovep } from "../../../services/covep-service";
import { editSimulation } from "../../../services/simulations-service";

const errorMessage = `Infelizmente não conseguimos processar a criação do covep. 
  Tente novamente mais tarde`;

const lossJustification = [
  {
    id: 1,
    name: "Condição Comercial",
  },
  { id: 2, name: "Crédito" },
  { id: 3, name: "Entrega" },
  { id: 4, name: "Estocado" },
];

const justifyItems = [
  {
    id: 1,
    name: "Pedido dia p/ dia",
  },
  { id: 2, name: "Carga incompleta" },
  { id: 3, name: "Logística fechada no dia seguinte" },
  { id: 4, name: "Pedido após as 16h" },
  { id: 5, name: "Caminhão quebrado" },
];

const justifyCredit = [
  { id: 1, name: "Inadimplência" },
  { id: 2, name: "Pendência de documento" },
  { id: 3, name: "Falta assinatura de contrato " },
  { id: 4, name: "Atraso análise de crédito" },
  { id: 5, name: "Crédito 100% tomado" },
];

export default function CovepModal({ simulationData, open, setOpen }) {
  const accessToken = localStorage.getItem("token");
  const [selectedReason, setSelectedReason] = useState("");
  const [justify, setJustify] = useState("");
  const [competitorPrice, setCompetitorPrice] = useState("");
  const [competitorId, setCompetitorId] = useState("");
  const [competitorList, setCompetitorList] = useState([]);
  const handleClose = () => setOpen(false);

  const verifyWhatReasonIs = (selectedReason) => {
    if (selectedReason === 2) {
      return justifyCredit.find((i) => i.id === justify).name;
    }

    if (selectedReason === 3) {
      return justifyItems.find((i) => i.id === justify).name;
    }

    return "";
  };

  const registerCovep = async () => {
    const verify = verifyWhatReasonIs(selectedReason);

    const data = {
      client_id: simulationData.client_id,
      product_id: simulationData.product_id,
      competitor_id: competitorId,
      company_id: simulationData.company_id,
      city_id: simulationData.city_id,
      user_id: simulationData.user_id,
      volume: simulationData.volume,
      preco: +competitorPrice,
      prazo: simulationData.prazo,
      simulacao_id: simulationData.id,
      preco_custo: simulationData.preco_compra || "",
      data_inclusao: simulationData.dt_simulation.split("T")[0],
      motivo: lossJustification.find((l) => l.id === selectedReason).name,
      sub_motivo: verify,
    };

    const covepId = await createCovep(accessToken, data);

    const editData = {
      id: simulationData.id,
      covep_id: covepId,
      status: "covep",
    };

    await editSimulation(accessToken, editData);

    alert("Covep cadastrado com sucesso.");

    window.location.reload(true);
    try {
    } catch (error) {
      alert(errorMessage);
    }
  };

  useEffect(() => {
    async function getCompetitorsList() {
      const result = await getCompetitors(accessToken);

      if (!result) return;
      setCompetitorList(
        result.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        )
      );
    }
    getCompetitorsList();
  }, [accessToken]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="box-covep" sx={modalStyle}>
        <form className="form-container">
          <h1>Cadastrar Covep</h1>

          <SelectInput
            value={selectedReason}
            name="Qual o motivo da perda?"
            setValue={setSelectedReason}
            selectValues={lossJustification}
          />

          {[3].includes(selectedReason) && (
            <SelectInput
              value={justify}
              name="Justifique"
              setValue={setJustify}
              selectValues={justifyItems}
            />
          )}

          {[2].includes(selectedReason) && (
            <SelectInput
              value={justify}
              name="Justifique"
              setValue={setJustify}
              selectValues={justifyCredit}
            />
          )}

          <TextField
            label="Confirme o preço do concorrente"
            name="competitor_price"
            onChange={(e) => setCompetitorPrice(e.target.value)}
            type="number"
            inputProps={{
              autoComplete: "off",
              step: "0.0001",
            }}
          />

          <SelectInput
            value={competitorId}
            name="Qual o concorrente?"
            setValue={setCompetitorId}
            selectValues={competitorList}
          />

          <Button variant="contained" onClick={registerCovep}>
            Cadastrar
          </Button>
        </form>
      </Box>
    </Modal>
  );
}
